import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { Observable } from 'rxjs/Observable';
import { User } from '../model/user.class';
import { Version } from '../model/version.class';

@Component({
    selector: 'app-media-version',
    templateUrl: './media.version.component.html'
})
export class MediaVersionComponent implements OnInit {

    @Input() mediaId;

    versionsFalse: Version[];
    versions: Version[];
    showAll = false;
    showVersionsText = 'Veraltete Versionen anzeigen';
    columns: Array<any> = [
        {
            title: 'Versionsnummer',
            name: 'number',
            sort: 'asc'
        },
        {
            title: 'Erstellungsdatum',
            name: 'createdAt',
            sort: '',
            pipe: 'dateTime'
        },
        {
            title: 'Kommentar',
            name: 'comment',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Kommentar filtern' }
        },
        {
            title: 'Status',
            name: 'versionStatus',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Status filtern' }
        }
    ];

    constructor(public userService: UserService) { }

    ngOnInit() {
        this.userService.getBy('version', this.mediaId, 'media').subscribe(data => {
            this.versions = data as Version[];
        });
    }

    showOldVersions() {
        if (this.showAll) {
            this.showAll = false;
            this.showVersionsText = 'Veraltete Versionen anzeigen';
        } else {
            this.showAll = true;
            this.showVersionsText = 'Nur neue Versionen anzeigen';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/mediaVersion/media.version.component.ts